import React, { useContext } from 'react'
import Context from '../../context'
import TextAreaHtml from '../TextAreaHtml'

function Index() {
  const { formObject, setFormObject } = useContext(Context)

  const handleRolesTextArea = value => {
    setFormObject(data => {
      return { ...data, roles: value }
    })
  }

  const handleRewardTextArea = value => {
    setFormObject(data => {
      return { ...data, reward: value }
    })
  }
  return (
    <>
      <h5>Regras do Desafio</h5>
      <br />
      <div className="row">
        <TextAreaHtml
          className="club-html-editor"
          value={formObject.roles}
          handleEditor={handleRolesTextArea}
          placeholder="Regras do Desafio"
        />
        <TextAreaHtml
          className="club-html-editor"
          value={formObject.reward}
          handleEditor={handleRewardTextArea}
          placeholder="Recompensas"
        />
      </div>
      <div className="row">
        <div className="col-md-2 col-sm-4 form-group" style={{ marginBottom: '20px' }}>
          <label htmlFor="numberOfWinners">Número de vencedores</label>
          <input
            value={formObject.numberOfWinners}
            min="1"
            onChange={e => setFormObject({ ...formObject, numberOfWinners: e.target.value })}
            type="number"
            className="form-control"
            id="numberOfWinners"
          />
        </div>
      </div>
    </>
  )
}

export default Index
